module.exports = "https://cdn.realtymogul.com/static/media/check_wht.c656e4f9.svg";